import { render, staticRenderFns } from "./NecessaryProductsPanelProduct.vue?vue&type=template&id=13ea2155&"
import script from "./NecessaryProductsPanelProduct.vue?vue&type=script&lang=ts&"
export * from "./NecessaryProductsPanelProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports